import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'

import { Header } from './Header'
import { Content } from './Content'

// DetailedBudget is tightly coupled to a formik context that has a field called detailed_budget
// and use_current_expense_for_retirement
export const DetailedBudget = ({
  isRetired,
  readOnly,
  budgetCategories
}) =>
  <Box
    component='section'
    className='detailed-budget'
  >
    <Header
      isRetired={isRetired}
      readOnly={readOnly}
    />
    <Content
      budgetCategories={budgetCategories}
      readOnly={readOnly}
    />
  </Box>

DetailedBudget.propTypes = {
  isRetired: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  budgetCategories: PropTypes.object.isRequired,
}
